export default [
  {
    path: '/loan',
    name: 'loan',
    component: () => import('@/views/loan/Loan.vue'),
    meta: {
      title: 'Loan',
      requiresAuth: true,
      action: 'browes',
      resource: 'Loan',
      pageTitle: 'Loan',
      breadcrumb: [
        {
          text: 'Loan',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/loan/edit/:id',
    name: 'edit-loan',
    component: () => import('@/views/loan/control-loan/AddEditLoan.vue'),
    meta: {
      title: 'Edit Loan',
      requiresAuth: true,
      pageTitle: 'Loan',
      breadcrumb: [
        {
          text: 'Loan',
          to: '/loan',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
